/* eslint-disable */
import React, { Component, PropTypes } from 'react';
import { TetheredSelect } from 'containers';
import { AutoSizer, List } from 'react-virtualized';
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';
import { Option, Value } from 'components';
import styles from './VirtualizedSelect.css';
import Select from '../Select/Select';

const debug = _debug('app:VirtualizedSelect');

export default class VirtualizedSelect extends Component {
  static propTypes = {
    maxHeight: PropTypes.number.isRequired,
    optionHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
    optionRenderer: PropTypes.func,
    type: PropTypes.string.isRequired,
    hintText: PropTypes.string.isRequired,
    updateFilter: PropTypes.func,
    applyFilter: PropTypes.func,
    allFilters: PropTypes.shape({}),
    filterValues: PropTypes.arrayOf(PropTypes.string),
    placeholder: PropTypes.string,
    activeFilter: PropTypes.func,
    replica: PropTypes.func,
    singleSelect: PropTypes.bool,
    activeIndex: PropTypes.number,
    updateNameSearchParameter: PropTypes.func,
    updateStreetSearchParameter: PropTypes.func,
    handleMarketDivisionChange: PropTypes.func,
    className: PropTypes.shape({}),
    menuStyle: PropTypes.shape({}),
    updateWritingAgentParameter: PropTypes.func,
    currentLanguage: PropTypes.string,
    isAdminScreen: PropTypes.bool,
    updateSelectedRecords: PropTypes.func,
    isFooter: React.PropTypes.string,
    zipSearch: React.PropTypes.string,
    citySearch: React.PropTypes.string,
    searchBoxOpen: React.PropTypes.string
  };

  static defaultProps = {
    maxHeight: 165,
    optionHeight: 35,
    tetherToWindow: true
  };

  constructor (props, context) {
    super(props, context);
    this.state = { value: null, searchInputValue: '' };
    this._renderMenu = this._renderMenu.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this);
    debug(this.props.type);
  }

  handleSelectChange(value) {
    this.props.replica && this.props.replica(this.props.options);
    this.props.activeFilter && this.props.activeFilter(this.props.type);
    this.props.updateFilter && this.props.updateFilter(this.props.type, value).then(() => {
      this.props.applyFilter && this.props.applyFilter();
      this.props.callCloseCarousel && this.props.callCloseCarousel(true);
      this.props.updateNameSearchParameter && this.props.updateNameSearchParameter('', this.props.activeIndex);
      this.props.updateWritingAgentParameter && this.props.updateWritingAgentParameter('', this.props.activeIndex);
      const isCampaignInArray = this.props.allFilters ? this.props.allFilters.leadType.find(element => element === 'Campaign') : null;
      const isActiveLineOneArray = this.props.allFilters ? this.props.allFilters.lineOneManager : null;
      if (this.props.type === 'leadType' && (isCampaignInArray === undefined || isCampaignInArray === null)) {
        if (this.props.allFilters.campaign.length > 0) {
          this.props.updateFilter('campaign').then(() => {
            this.props.applyFilter && this.props.applyFilter();
            this.props.updateNameSearchParameter && this.props.updateNameSearchParameter('', this.props.activeIndex);
            this.props.updateStreetSearchParameter && this.props.updateStreetSearchParameter('', this.props.activeIndex);
          });
        } 
        if (this.props.allFilters.campaignPurpose.length > 0) {
          this.props.updateFilter('campaignPurpose').then(() => {
            this.props.applyFilter && this.props.applyFilter();
            this.props.updateNameSearchParameter && this.props.updateNameSearchParameter('', this.props.activeIndex);
            this.props.updateStreetSearchParameter && this.props.updateStreetSearchParameter('', this.props.activeIndex);
          });
        }
      }
      if (this.props.type === 'lineOneManager' && (isActiveLineOneArray === undefined || isActiveLineOneArray === null || isActiveLineOneArray.length === 0)) {
        if (this.props.allFilters.activeLastSellingAgentName.length > 0) {
          this.props.updateFilter('activeLastSellingAgentName').then(() => {
            this.props.applyFilter && this.props.applyFilter();
            this.props.updateNameSearchParameter && this.props.updateNameSearchParameter('', this.props.activeIndex);
            this.props.updateStreetSearchParameter && this.props.updateStreetSearchParameter('', this.props.activeIndex);
          });
        }
      }

      if (!__MANAGE__ && !this.props.isAdminScreen && this.props.activeIndex !== 2 && this.props.isFooter !== 'yes') {
        this.props.updateSelectedRecords('removeAll');
      }
      this.props.updateNameSearchParameter && this.props.updateNameSearchParameter('', this.props.activeIndex);
      this.props.updateStreetSearchParameter && this.props.updateStreetSearchParameter('', this.props.activeIndex);
    });
  }

  getValueSet(){
    if(this.props.singleSelect) {
      return this.props.filterValues && this.props.filterValues.length ?
      [this.props.filterValues[this.props.filterValues.length - 1]]: this.props.filterValues;
    }
    return this.props.filterValues && 
          this.props.filterValues.map(element => ({
            clearableValue: false,
            value: element,
            label: element
          }));
  }
  onInputChange = (event) => {
    debug('What is the search input value', event.target.value);
    this.setState({searchInputValue: event.target.value});
  }

  /** See ListScroll#recomputeRowHeights */
  recomputeOptionHeights (index = 0) {
    if (this.virtualScroll) {
      this.virtualScroll.recomputeRowHeights(index)
    }
  }

  render () {
    const citySearchValue = this.props.citySearch;
    const zipSearchValue = this.props.zipSearch;
    if (this.props.tetherToWindow) {
      return (
        <TetheredSelect
          {...this.props}
          searchable={false}
          autosize={false}
          multi
          onChange={this.handleSelectChange}
          value={this.getValueSet()}
          menuRenderer={this._renderMenu}
          menuStyle={this.props.menuStyle ? this.props.menuStyle : { overflow: 'hidden' }}
          placeholder={this.props.placeholder || (this.props.currentLanguage === 'es' ? 'Selección requerida' : 'Selection Required')}
          inputProps={{className: styles.inputElement, placeholder: `${this.props.currentLanguage === 'es' ? (this.props.isAdminScreen ? 'Buscar' : 'Búsqueda por') : 'Search'} ${this.props.hintText}`}}
          valueComponent={Value}
          noResultsText={this.props.currentLanguage === 'es' ? 'Resultados no encontrados' : 'No results found'}
        />
      )
    }

    return (
      <Select
        {...this.props}
        searchable={false}
        autosize={false}
        multi
        onChange={this.handleSelectChange}
        updateSelectedRecords={this.props.updateSelectedRecords}
        value={this.getValueSet()}
        menuRenderer={this._renderMenu}
        menuStyle={this.props.menuStyle ? this.props.menuStyle : ((this.props.searchBoxOpen !== 'searchBoxOpen') ? { overflow: 'hidden' } : { padding: 0 })}
        placeholder={(citySearchValue !== 'citySearch' && zipSearchValue !== 'zipSearch') ? this.props.placeholder || (this.props.currentLanguage === 'es' ? 'Selección requerida' : 'Selection Required') : ''}
        inputProps={{className: styles.inputElement, placeholder: `${this.props.currentLanguage === 'es' ? (this.props.isAdminScreen ? 'Buscar' : 'Búsqueda por') : 'Search'} ${this.props.hintText}`}}
        valueComponent={Value}
        tetherToWindow={this.props.tetherToWindow}
        noResultsText={this.props.currentLanguage === 'es' ? 'Resultados no encontrados' : 'No results found'}
        isAdminScreen={this.props.isAdminScreen}
        activeIndex={this.props.activeIndex}
        searchBoxOpen={this.props.searchBoxOpen}
      />
    )
  }

  // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing
  _renderMenu ({ focusedOption, focusOption, labelKey, options, selectValue, removeValue, valueArray }) {
    const focusedOptionIndex = options.indexOf(focusedOption)
    const height = this._calculateListHeight({ options })
    const activeIndex = this.props.activeIndex;

    function wrappedRowRenderer ({ index, key, style }) {
      const option = options[index]

      return Option({
        focusedOption,
        focusedOptionIndex,
        focusOption,
        key,
        labelKey,
        option,
        optionIndex: index,
        options,
        selectValue,
        removeValue,
        style,
        valueArray,
        activeIndex
      });
    }

    return (
      <div className={styles.dropdownContainer}>
        <AutoSizer disableHeight>
          {({ width }) => (
            <List
              className="VirtualSelectGrid"
              height={height}
              ref={ref => this.virtualScroll = ref}
              rowCount={options.length}
              rowHeight={({ index }) => this.getOptionHeight({
                option: options[index]
              })}
              rowRenderer={wrappedRowRenderer}
              scrollToIndex={focusedOptionIndex}
              width={width}
            />
          )}
        </AutoSizer>
      </div>
    );
  }

  _calculateListHeight({ options }) {

    const { maxHeight, hiddenSearch } = this.props;
    let height = 0;

    if (this.props.hiddenSearch) {
      return maxHeight;
    }
    for (let optionIndex of options) {
      const option = options[optionIndex];

      height += this.getOptionHeight({ option });

      if (height > maxHeight) {
        return maxHeight;
      }
    }

    return height;
  }

  getOptionHeight({ option }) {
    const { optionHeight } = this.props;

    return optionHeight instanceof Function
      ? optionHeight({ option })
      : optionHeight;
  }

}



// WEBPACK FOOTER //
// ./src/containers/VirtualizedSelect/VirtualizedSelect.js